import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getDashboardData } from '../slice/contactUsSlice';
import { FaBoxOpen, FaImages, FaBullhorn, FaEnvelopeOpenText, FaRegNewspaper } from 'react-icons/fa';
function Home() {
  const dispatch = useDispatch();
  const Data = useSelector((state) => state.contactus);
  const tableCounts = Data?.dashboard?.table_counts || {};
  useEffect(() => {
    dispatch(getDashboardData());
  }, [dispatch]);

  const cards = useMemo(
    () => [
      { key: 'product', label: 'Total News', icon: FaBoxOpen, color: 'warning' },
      { key: 'story', label: 'Total Story', icon: FaRegNewspaper, color: 'info' },
      { key: 'gallery', label: 'Total Gallery', icon: FaImages, color: 'secondary' },
      // { key: 'media', label: 'Total Video', icon: FaPhotoVideo, color: 'dark' },
      { key: 'contactus', label: 'Total Contact Us', icon: FaEnvelopeOpenText, color: 'primary' },
      { key: 'banner', label: 'Total Advertising', icon: FaBullhorn, color: 'danger' }
    ],
    []
  );

  return (
    <>
      <div className="container-fluid px-lg-5 mt-5">
        <div className="d-sm-flex align-items-center justify-content-between mb-4 mainheadig">
          <h1 className="h3 mb-0 text-white">Dashboard</h1>
        </div>
        <div className="row  mt-5">
          {cards.map((card) => {
            const Icon = card.icon;
            return (
              <div className="col-xl-3 col-md-6 mb-4" key={card.key}>
                <div className={`card border-left-${card.color} shadow h-100 py-2`}>
                  <div className="card-body">
                    <div className="row no-gutters align-items-center">
                      <div className="col mr-2">
                        <div className={`text-xs font-weight-bold text-${card.color} text-uppercase mb-1`}>{card.label}</div>
                        <div className="h5 mb-0 font-weight-bold text-gray-800">{tableCounts?.[card.key] ?? 0}</div>
                      </div>
                      <div className="col-auto">
                        <Icon className="fa-2x text-gray-300" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default Home;
